
export const COURSE_ARCHIVE_OVERLAP_PERIOD = 30;
export enum COURSE_STATUS  {
    ARCHIVED = "ARCHIVED",
    EXPIRED = "EXPIRED",
    RELEASED = "RELEASED"
}